import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL, LOCATION_ID } from "..";
import { Spinner } from "react-bootstrap";
import PurchaseBillListLayer from "../components/PurchaseBillListLayer";

const PurchaseBillListPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

   const locationId = localStorage.getItem('locationID')

 const fetchBills = async () => {
  setLoading(true);
  try {
    const res = await fetch(`${API_URL}/api/purchase-bills?locationId=${locationId}`);
    const result = await res.json();


    setData(result.reverse());

  } catch (err) {
    console.error("Error fetching bills:", err);
  }
  setLoading(false);
};

  useEffect(() => {
    fetchBills();
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb title="Purchase Bills - List" />
      {loading && <div className="text-center mt-4"><Spinner /></div>}
      {/* {!loading  && (
        <div className="text-center mt-4"><p>No Bill data found....</p></div>
      )} */}
      {!loading && <PurchaseBillListLayer billsData={data} />}
    </MasterLayout>
  );
};

export default PurchaseBillListPage;
